import { render, staticRenderFns } from "./GridTest.vue?vue&type=template&id=af889f38&scoped=true&"
var script = {}
import style0 from "./GridTest.vue?vue&type=style&index=0&id=af889f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af889f38",
  null
  
)

export default component.exports